import { Cartesian3, CustomDataSource, Entity, PropertyBag, Billboard, BillboardCollection } from 'cesium';
import { trips } from '../Itinerary/Travel.tsx';
export function createTravelSource(): CustomDataSource {
        let travelSource = new CustomDataSource();
        let locations = new Map<string, Entity>();
        for (const trip of trips) {
            for (const destination of trip.destinations) {
                let key = JSON.stringify(destination.coords);
                if (locations.has(key)) {
                    (locations.get(key) as any).trips.push({ name: trip.name, start: trip.start, end: trip.end, dest: destination});
                    continue;
                }

                const img = new Image();
                img.src = trip.coverImg;
                let ent = travelSource.entities.add({
                    position: Cartesian3.fromDegrees(destination.coords.lon, destination.coords.lat),
                    properties: new PropertyBag(),
                });
                let travelArray = [{ name: trip.name, start: trip.start, end: trip.end, dest: destination}];
                ent.addProperty("trips");
                (ent as any).trips = travelArray;
                locations.set(key, ent);
                img.onload = () => {
                    const ar = img.naturalWidth / img.naturalHeight;
                    const height = 30;
                    const width = height * ar;
                    ent.billboard = new Billboard({
                        image: trip.coverImg,
                        height,
                        width,
                        verticalOrigin: 1,
                    } as Billboard.ConstructorOptions, new BillboardCollection()) as any;
                }
            }
        }
        return travelSource;
}
